module.exports = __webpack_public_path__ + "static/media/icon-filter.51173c81.svg";